import { Minus, Plus } from 'lucide-react';
import './QuantityInput.css';
const QuantityInput = ({
  quantity,
  setQuantity,
  cartPage,
  productId,
  variantId,
  variantQty,
}) => {
  return (
    <>
      <div className="input-group quantity mx-auto ">
        {/* Minus Button */}
        <button
          className="btn border-0 d-flex align-items-center justify-content-center"
          type="button"
          id="button-addon1"
          disabled={quantity <= 1}
          onClick={() => {
            cartPage
              ? setQuantity('decrease', productId, variantId)
              : setQuantity(quantity - 1);
          }}
          // style={{ width: '40px', height: '40px' }}
        >
          <Minus size={20} />
        </button>

        {/* Input Box */}
        <input
          type="text"
          className="form-control text-center fw-bold"
          value={quantity}
          readOnly
          aria-label="Quantity"
          aria-describedby="button-addon1"
          style={{ height: '40px', maxWidth: '40px', fontSize: '16px' }}
        />

        {/* Plus Button */}
        <button
          className="btn border-0 d-flex align-items-center justify-content-center"
          type="button"
          id="button-addon2"
          disabled={quantity >= variantQty}
          onClick={() => {
            cartPage
              ? setQuantity('increase', productId, variantId)
              : setQuantity(quantity + 1);
          }}
          // style={{ width: '40px', height: '40px' }}
        >
          <Plus size={20} />
        </button>
      </div>
    </>
  );
};
export default QuantityInput;
